// src/components/common/ErrorBoundary.js
// 🎯 [iOS Fix] React 에러 발생 시 빈 화면 대신 에러 메시지 표시
// 기존 기능에 영향 없음 - 에러 발생 시에만 동작

import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }

    static getDerivedStateFromError(error) {
        // 에러 발생 시 상태 업데이트
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // 에러 로깅
        console.error('[ErrorBoundary] 앱 에러 발생:', error);
        console.error('[ErrorBoundary] 컴포넌트 스택:', errorInfo?.componentStack);

        this.setState({ errorInfo });
    }

    handleRetry = () => {
        // 에러 상태 초기화 후 재시도
        this.setState({ hasError: false, error: null, errorInfo: null });
    };

    render() {
        if (this.state.hasError) {
            // 에러 발생 시 폴백 UI 표시
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                    backgroundColor: '#f0f2f5',
                    padding: '20px',
                    textAlign: 'center'
                }}>
                    <h1 style={{
                        fontSize: '1.5rem',
                        fontWeight: '700',
                        color: '#333',
                        marginBottom: '16px'
                    }}>
                        ⚠️ 앱 로드 중 오류가 발생했습니다
                    </h1>
                    <p style={{
                        fontSize: '0.9rem',
                        color: '#666',
                        marginBottom: '8px',
                        maxWidth: '300px'
                    }}>
                        {this.state.error?.message || '알 수 없는 오류'}
                    </p>
                    <p style={{
                        fontSize: '0.75rem',
                        color: '#999',
                        marginBottom: '24px'
                    }}>
                        앱을 다시 시작하거나 잠시 후 재시도해 주세요.
                    </p>
                    <button
                        onClick={this.handleRetry}
                        style={{
                            padding: '12px 24px',
                            fontSize: '1rem',
                            fontWeight: '600',
                            color: 'white',
                            backgroundColor: '#4CAF50',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer'
                        }}
                    >
                        다시 시도
                    </button>
                </div>
            );
        }

        // 정상 동작 시 children 그대로 렌더링
        return this.props.children;
    }
}

export default ErrorBoundary;
